import React from "react";
import BankGroup from "./BankGroup";

class AccountsCollection extends React.Component {

    constructor(props) {
        super(props);
    }

    render () {
        const { userIsLoading, accounts, accountsLoading, accountsError, csrfToken } = this.props;

        if (userIsLoading || accountsLoading) {
            return (<div className={"ui segment"}>
                        <img src="img/loader-dynamic.svg" href={"https://loading.io/asset/398618"} className={"ui centered image"}/>
                    </div>)
        }

        if (accounts == null || typeof accounts == 'undefined') {
            return (<div>Error: {accountsError}</div>)
        }

        return (
            <>
                {Object.entries(accounts).map(([itemId, accounts]) => (
                    <div key={itemId}>
                        <BankGroup basicAccounts={accounts} plaidItemId={itemId} csrfToken={csrfToken}/>
                    </div>

                ))}
            </>
        )
    }

}

export default AccountsCollection;